/* FOM · tipos do dominio, espelhando contracts/v1.

   Estes tipos descrevem o que a API DEVOLVE. Nao sao o modelo do banco e nao
   sao o estado da tela — a separacao e proposital e esta em store.ts. */

export type StatusClass = 'E1' | 'E2' | 'E3' | 'E4' | 'ND' | 'TOBE' | 'MIX';
export type NodeOrigin = 'base' | 'user';
export type ChildKind = 'kids' | 'flow' | null;
export type RelKind = 'trans' | 'flow';
export type MemberRole = 'viewer' | 'editor' | 'owner';

/* Os 13 tipos de SISTEMA (D-FOM-012). Continuam sendo o vocabulario do
   produto — e sobre eles que a gramatica visual e as perspectivas decidem.
   Desde o gate 0073 a taxonomia e EXTENSIVEL: cada organizacao pode criar
   tipos proprios no catalogo (node_type_catalog), e por isso o campo do no e
   `string`, nao esta uniao. Tipo desconhecido nunca quebra a tela: cai no
   fallback de `rotuloTipo` e na gramatica visual neutra. */
export type NodeType =
  | 'org' | 'mgmt' | 'unit' | 'func' | 'activity' | 'process' | 'network'
  | 'partner' | 'modal' | 'service' | 'gest' | 'system' | 'case';

/* Um tipo como o catalogo o descreve. `key` e a identidade estavel (o que o
   no guarda e o que um agente cita); `label` e o que a pessoa le. */
export type TipoDeNo = {
  key: string;
  label: string;
  description: string | null;
  origin: 'system' | 'user';
  status: 'active' | 'archived';
  scope: 'system' | 'organization';
  nodes: number;
  created_at: string;
  archived_at: string | null;
};

/* `origin` diz se a afirmacao vem da BASE congelada ou foi escrita por
   alguem depois. Duas frases identicas com origens diferentes NAO valem o
   mesmo, e a tela precisa poder mostrar isso. */
export type KnowItem = { text: string; st: StatusClass; origin?: NodeOrigin };

export type FomNode = {
  id: string;
  external_id: string;
  origin: NodeOrigin;
  parent_external_id: string | null;
  child_kind: ChildKind;
  ordinal: number;
  depth: number | null;
  code: string | null;
  name: string;
  /* chave de um tipo do catalogo: os 13 de sistema ou um criado pela
     organizacao (gate 0073) */
  node_type: string | null;
  st: StatusClass;
  summary: string | null;
  src: string | null;
  next_step: string | null;
  step_kind: string | null;
  flow_title: string | null;
  layer: string | null;
  removed_at: string | null;
  updated_at: string;
  know: KnowItem[];
  gaps: string[];
};

export type Relation = {
  id: string;
  from: string;
  to: string;
  type: string;
  kind: RelKind;
  payload: string | null;
  origin: NodeOrigin;
  ordinal: number;
};

export type Organization = { id: string; slug: string; name: string; role: MemberRole };

export type MapInfo = {
  id: string; slug: string; name: string; base_template: string;
  base_seed_sha256: string | null;
  base_fingerprint: string | null;
  base_imported_at: string | null;
};

export type MapCounts = {
  nodes: number; relations: number; know: number; gaps: number;
  base_nodes: number; user_nodes: number;
};

export type Fingerprint = {
  fingerprint_now: string;
  fingerprint_base_only: string;
  fingerprint_reference: string | null;
  matches_frozen_base: boolean;
  base_only_intact: boolean | null;
  nodes_walked: number;
};

/* A trilha do mapa distingue pessoa de maquina. Sem isso, uma acao do agente
   apareceria com a mesma voz de uma acao humana — e o leitor nao teria como
   saber que quem agiu foi um programa. */
export type HistoryEntry = {
  id: string | number;
  at: string;
  action: string;
  author: string | null;
  actor_type?: 'human' | 'agent';
  agent?: string | null;
};

export type Sessao = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  user: { id: string; name: string; email: string };
};

/* ---------------------------------------------------------- investigacao --

   O ciclo epistemologico do FOM, que e a razao de o produto existir:

     ND -> pergunta -> evidencia necessaria -> evidencia encontrada
        -> resposta -> classificacao deliberada (COM TETO) -> conhecimento

   O TETO nao e calculado aqui. Ele vem de GET .../allowed, que consulta a
   MESMA funcao usada pelo trigger C-07. A tela desabilita o que nao cabe; o
   banco continua sendo quem recusa. */

export type InvStatus = 'aberta' | 'respondida' | 'encerrada';

export type EvidenceType = 'Tela do sistema' | 'Documento' | 'Relato do operador' | 'Outro';

export type Evidence = {
  id: string;
  type: EvidenceType;
  ref: string | null;
  evidence_date: string | null;
  description: string | null;
  partial: boolean;
  created_at: string;
};

export type ClosingEffect = 'know' | 'reclass' | 'log';

export type Closing =
  | { effect: 'log'; kept: string; reason: string }
  | { effect: 'know' | 'reclass'; from: string; to: StatusClass; evidenceRefs: string };

export type Investigation = {
  id: string;
  code: string;
  node_external_id: string;
  parent_code: string | null;
  status: InvStatus;
  question: string;
  needed: string | null;
  origin_gap: string | null;
  answer_text: string | null;
  closing: Closing | null;
  created_at: string;
  evidence: Evidence[];
};

/* A lista e mais magra que o detalhe — de proposito: a listagem nao carrega
   evidencia nem resposta. */
export type InvestigationResumo = {
  code: string;
  node_external_id: string;
  status: InvStatus;
  question: string;
  created_at: string;
};

/* ------------------------------------------------------------- contrato --- */

export const CONTRATO_LISTAS = [
  'missao', 'inputs', 'fontes', 'precond', 'decisoes', 'atividades', 'sistemas',
  'outputs', 'consumidores', 'documentos', 'excecoes', 'escalonamento',
  'indicadores', 'riscos', 'controles', 'dependencias',
] as const;

export const CONTRATO_AUTOMACAO = [
  'trigger', 'decision_rules', 'input_schema', 'output_schema',
  'exception_rules', 'escalation_rule',
] as const;

export type CampoLista = (typeof CONTRATO_LISTAS)[number];
export type CampoAuto = (typeof CONTRATO_AUTOMACAO)[number];

export type AutomationLevel =
  | 'automático' | 'semi-automático' | 'humano' | 'aprovação humana' | 'exceção humana';

export type ContractBody = Partial<Record<CampoLista, string[]>> & Partial<Record<CampoAuto, string>>;

export type Contract = {
  id: string;
  node_external_id: string;
  origem: StatusClass;
  automation_level: AutomationLevel | null;
  automation_candidate: boolean;
  body: ContractBody;
  updated_at: string;
};

/* ------------------------------------------------------------ publicacao -- */

/* O snapshot ja vem SEM a camada PRIVATE — o scrub e do banco (C-08). O que
   chega aqui e o que o mundo pode ver. */
export type PublicationResumo = {
  id: string;
  version: number;
  published_at: string;
  published_by: string | null;
  snapshot_sha256: string;
};

export type Publication = PublicationResumo & { snapshot: unknown };

/* Rotulos de APRESENTACAO. D-FOM-012: o valor de dominio e o canonico em
   minusculas; o portugues vive aqui, nunca no dado. */
export const ROTULO_TIPO: Record<NodeType, string> = {
  org: 'Organizacao', mgmt: 'Direcao', unit: 'Unidade', func: 'Funcao',
  activity: 'Atividade', process: 'Processo', network: 'Rede',
  partner: 'Parceiro', modal: 'Modal', service: 'Servico', gest: 'Gestao',
  system: 'Sistema', case: 'Caso',
};

/* ROTULO DE TIPO — ponto unico (gate 0073).
   Antes, dez lugares indexavam ROTULO_TIPO direto; com taxonomia extensivel
   isso escreveria "undefined" na tela no dia em que um tipo novo aparecesse
   (e o TypeScript nao avisaria, porque Record<NodeType,string> promete
   `string`). Aqui a ordem e: rotulo do catalogo → rotulo de sistema →
   a propria chave apresentavel. Nunca inventa nome; no maximo mostra a
   chave que o dado realmente tem. */
let CATALOGO_TIPOS: Map<string, string> = new Map();

export function definirCatalogoTipos(tipos: { key: string; label: string }[]): void {
  CATALOGO_TIPOS = new Map(tipos.map((t) => [t.key, t.label]));
}

export function rotuloTipo(chave: string | null | undefined): string | null {
  if (!chave) return null;
  const doCatalogo = CATALOGO_TIPOS.get(chave);
  if (doCatalogo) return doCatalogo;
  const doSistema = (ROTULO_TIPO as Record<string, string | undefined>)[chave];
  if (doSistema) return doSistema;
  /* chave desconhecida (catalogo ainda nao carregou, snapshot antigo, tipo de
     outra origem): mostra a chave legivel, jamais "undefined" */
  return chave.replace(/[-_]+/g, ' ').replace(/^./, (c) => c.toUpperCase());
}

export const ROTULO_ST: Record<StatusClass, string> = {
  E1: 'E1 · comprovado',
  E2: 'E2 · documental parcial',
  E3: 'E3 · relato do operador',
  E4: 'E4 · hipotese',
  ND: 'ND · nao observado',
  TOBE: 'TO-BE · futuro',
  MIX: 'MIX · agregado',
};

/* Legenda da taxonomia epistemica (microfase legenda-classificacao).
   TERMINOLOGIA OFICIAL ja existente, nada novo: ROTULO_ST acima,
   contracts/v1/common.schema.json (statusClass.description) e o teto por
   evidencia C-07 (tela/documento completo -> E1; parcial -> E2; relato ->
   E3; ND/E4/TOBE "nao afirmam nada sobre a realidade observada" —
   FOM-ARQ-0011 §2). Apresentacao, nunca dominio. */
export const DESCRICAO_ST: Record<StatusClass, string> = {
  E1: 'comprovado por tela ou documento completo. Exige referencia da evidencia.',
  E2: 'sustentado por tela ou documento parcial. Exige referencia da evidencia.',
  E3: 'relato do operador. O teto honesto quando nao ha evidencia.',
  E4: 'hipotese. Nao afirma nada sobre a realidade observada.',
  ND: 'nao observado. Declaracao honesta de ausencia.',
  TOBE: 'intencao futura declarada. NAO e evidencia de algo ja realizado.',
  MIX: 'agregado, calculado a partir dos filhos. Nunca autoral.',
};

export const COR_ST: Record<StatusClass, string> = {
  E1: '#3fb98f', E2: '#d9a441', E3: '#5b9bd5', E4: '#a97bd6',
  ND: '#8a8f98', TOBE: '#e06c9f', MIX: '#c9cdd4',
};

export const ROTULO_INV: Record<InvStatus, string> = {
  aberta: 'aberta · sem resposta',
  respondida: 'respondida · nao encerrada',
  encerrada: 'encerrada',
};

export const ROTULO_EFEITO: Record<ClosingEffect, string> = {
  know: 'gerar conhecimento novo',
  reclass: 'reclassificar o no',
  log: 'apenas registrar — nao muda o no',
};

export const ROTULO_CONTRATO: Record<string, string> = {
  missao: 'Missao', inputs: 'Entradas', fontes: 'Fontes', precond: 'Precondicoes',
  decisoes: 'Decisoes', atividades: 'Atividades', sistemas: 'Sistemas',
  outputs: 'Saidas', consumidores: 'Consumidores', documentos: 'Documentos',
  excecoes: 'Excecoes', escalonamento: 'Escalonamento', indicadores: 'Indicadores',
  riscos: 'Riscos', controles: 'Controles', dependencias: 'Dependencias',
  trigger: 'Gatilho', decision_rules: 'Regras de decisao',
  input_schema: 'Schema de entrada', output_schema: 'Schema de saida',
  exception_rules: 'Regras de excecao', escalation_rule: 'Regra de escalonamento',
};

/* ------------------------------------------------------ Operating Brain ---

   Tudo aqui e PROPOSTA, nunca fato. O tipo carrega essa distincao de proposito:
   quem renderiza precisa poder dizer na tela "isto e recomendacao do agente" e
   nao deixar o leitor confundir com dado do mapa. */

export type PoliticaDecisao =
  | 'auto' | 'requer_aprovacao' | 'somente_recomendacao' | 'bloqueada';

export type PropostaStatus =
  | 'pending' | 'approved' | 'rejected' | 'executed' | 'failed' | 'superseded';

export type BrainProposta = {
  code: string;
  kind: string;
  target_kind: 'node' | 'investigation' | 'map';
  target_ref: string | null;
  title: string;
  rationale: string;
  observations: string[];
  gaps: string[];
  risk: 'baixo' | 'medio' | 'alto';
  policy_decision: PoliticaDecisao;
  policy_reason: string;
  executable: boolean;
  action_kind: string | null;
  action_payload?: Record<string, unknown> | null;
  status: PropostaStatus;
  created_at: string;
  decided_at: string | null;
  decision_note?: string | null;
  executed_at: string | null;
  result?: Record<string, unknown> | null;
  provider?: string;
  effective_role?: MemberRole;
};

export type BrainStatus = {
  agent: string;
  granted: boolean;
  max_role?: MemberRole;
  effective_role: MemberRole | null;
  read_private: boolean;
  autonomous: boolean;
  pending: number;
  provider: string;
  last_run: {
    id: string; status: string; started_at: string;
    finished_at: string | null; error_code: string | null;
  } | null;
};

export type BrainEvento = {
  id: number | string;
  at: string;
  event: string;
  detail: string;
  actor_type: 'human' | 'agent';
  agent: string | null;
  actor_user: string | null;
  proposal_code: string | null;
};

export type BrainExecucao = {
  run_id: string;
  status: 'ok' | 'failed';
  provider: string;
  effective_role: MemberRole;
  read_private: boolean;
  observation: {
    nos_no_mapa: number;
    nos_examinados: number;
    investigacoes_examinadas: number;
    privado_disponivel: boolean;
  };
  propostas: { code: string; kind: string; title: string; status: string }[];
  error_code?: string;
};

/* Rotulos de apresentacao. O vocabulario interno do agente nao aparece cru na
   tela: "lacuna_sem_investigacao" nao diz nada a quem opera. */
export const ROTULO_PROPOSTA: Record<string, string> = {
  lacuna_sem_investigacao: 'Lacuna sem investigacao',
  investigacao_sem_evidencia: 'Investigacao parada',
  investigacao_pronta_para_encerrar: 'Pronta para encerrar',
  classificacao_sem_fonte: 'Classificacao sem fonte',
  publicacao_desatualizada: 'Publicacao desatualizada',
  no_sem_conhecimento: 'No nunca examinado',
};

export const ROTULO_POLITICA: Record<PoliticaDecisao, string> = {
  auto: 'executada automaticamente',
  requer_aprovacao: 'aguarda sua decisao',
  somente_recomendacao: 'recomendacao — nao ha acao automatica',
  bloqueada: 'bloqueada pela politica',
};

export const ROTULO_STATUS_PROPOSTA: Record<PropostaStatus, string> = {
  pending: 'aguardando decisao',
  approved: 'aprovada',
  rejected: 'recusada',
  executed: 'executada',
  failed: 'recusada pelo dominio',
  superseded: 'perdeu o sentido',
};
